import { TItemType, TSettingsRateCardType } from '@types';
import { matchesRateCard } from './matchesRateCard';

/** The live Item types that the Customer's rate card settings hold an Item template for, in the list's order. */
export const getItemTypesWithTemplate = (templates: TSettingsRateCardType[] | undefined, itemTypes: TItemType[]) => {
	return itemTypes.filter((itemType) => templates?.some((template) => matchesRateCard(template, 'ITEM', itemType.id)));
}
